import React from 'react';
import { createRoot } from 'react-dom/client';

import SuiThemeProvider from '@splashthat/sui/lib/components/SuiThemeProvider';
import { withInlineStylesAnchor } from 'utils/insertInlineStylesAnchor';

import UserConfirmation from '../components/UserConfirmation';

// Decorating the SuiThemeProvider with our custom anchor element.
const ThemeProvider = withInlineStylesAnchor(SuiThemeProvider);

export const fallbackUrl = (function () {
    let url = '';

    return {
        setUrl: (newUrl) => {
            url = newUrl;
        },
        getUrl: () => url,
    };
})();

export const getUserConfirmation = (message, callback) => {
    const modal = document.createElement('div');
    const root = createRoot(modal);
    document.body.appendChild(modal);

    const withCleanup = (answer) => {
        root.unmount(modal);
        document.body.removeChild(modal);
        if (!answer && fallbackUrl.getUrl() && window.location.pathname !== fallbackUrl.getUrl()) {
            window.history.pushState({}, '', fallbackUrl.getUrl());
        } else {
            callback(answer);
        }
    };

    root.render(
        <ThemeProvider>
            <UserConfirmation
                message={message}
                onCancel={() => withCleanup(false)}
                onConfirm={() => withCleanup(true)}
            />
        </ThemeProvider>,
    );
};
